import React from 'react'
import { useTranslation } from 'react-i18next'
import {Drawer, Layout} from 'antd'
import classNames from 'classnames'
import {ROUTES} from '@/router/routes'
import {Logo} from '@/components'
import {getPermissions, navigateUserAfterLogin} from '@/stores/auth/services'
import {Theme} from '@/constants'
import {MENU} from '@/constants/playwright-ids'
import ApplicationStepsContainer from '@/layouts/OnboardingLayout/components/ApplicationSteps/ApplicationStepsContainer'
import {Burger} from '@/layouts/MainLayout/components'
import {SiderLogoContainer} from '@/layouts/MainLayout/components/SiderLogoContainer'

import {SiderMenu} from '../'

import {SiderProps} from './props'
import styles from './OnboardingSider.scss'

const siderExpandedWidth = 304

export const OnboardingSider: React.FC<SiderProps> = (props) => {
    const { t } = useTranslation()
    const {isMobile, isCollapsed, setCollapsed, menuItems, selectedKeys, className} =
        props

    const renderHeader = () => (
        <div className={styles.header}>
            <Burger onClick={() => setCollapsed(!isCollapsed)} />
            <SiderLogoContainer>
                <Logo
                    onClick={() => navigateUserAfterLogin(getPermissions())}
                    href={ROUTES.home}
                    type={Theme.LIGHT}
                    isBlank={false}
                />
            </SiderLogoContainer>
        </div>
    )

    const renderContent = () => (
        <div className={classNames(styles.content, {[styles.mobile]: isMobile})}>
            {renderHeader()}
            <SiderMenu
                menuItems={menuItems}
                selectedKeys={selectedKeys}
                collapsed={isCollapsed}
            />
            <ApplicationStepsContainer />
        </div>
    )

    return isMobile ? (
        <Drawer
            open={!isCollapsed}
            placement='left'
            className={classNames(styles.drawer, className)}
            closable={false}
            width={siderExpandedWidth}
            onClose={() => setCollapsed(true)}
        >
            {renderContent()}
        </Drawer>
    ) : (
        <Layout.Sider
            className={classNames(styles.sider, className)}
            collapsible
            collapsed={isCollapsed}
            trigger={null}
            width={siderExpandedWidth}
            collapsedWidth={siderExpandedWidth}
            data-test-id={MENU}
        >
            {renderContent()}
        </Layout.Sider>
    )
}
